export default __webpack_public_path__ + "static/media/manual-cleaning-02.091fa3ae.png";